import { Stack } from "@mui/material";
import logo from "../img/logo.png";
import { Color } from "../constants";

const LogoBubble = ({ size = "70px" }) => {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: Color.primary,
        borderRadius: "50%",
        width: size,
        minWidth: size,
        height: size,
        // borderRadius: "50%",
        // width: "70px",
        // minWidth: "70px",
        // height: "70px",
      }}>
      <img src={logo} alt="logo" style={{ width: "75%" }} />
    </Stack>
  );
};

export default LogoBubble;
